import React, { useState, useEffect } from 'react';
import { object, func, bool } from 'prop-types';

import { CloneObject } from '../../../utils/helpers';
import { useFormErrors } from '../../hooks/useFormErrors';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';
import { useForm } from '@laramie/ui';
import { isValidString } from '../../../utils/validator';
import { InputCustom, FormError, FormLabel, Modal } from '../../common';


const TablaItemModal = (props) => {

  const entityInit = {
    id: 0,
		idTablaDefinicion: 0,
		idTablaVersion: 0,
		valor1: '',
		valor2: '',
		valor3: '',
		valor4: '',
		valor5: '',
		valor6: '',
		valor7: '',
		valor8: '',
		valor9: '',
		valor10: '',
		valorResultado: ''
  };

  const [entity, setEntity] = useState(entityInit)

  const [ formValues, formHandle, , formSet ] = useForm({
    valor1: '',
    valor2: '',
    valor3: '',
    valor4: '',
    valor5: '',
    valor6: '',
    valor7: '',
    valor8: '',
    valor9: '',
    valor10: '',
    valorResultado: ''
  });

  const mount = () => {
    setEntity(props.data.entity);
    formSet({
      valor1: (props.data.columnas[0]?.nombre) ? props.data.entity.valor1 : '',
      valor2: (props.data.columnas[1]?.nombre) ? props.data.entity.valor2 : '',
      valor3: (props.data.columnas[2]?.nombre) ? props.data.entity.valor3 : '',
      valor4: (props.data.columnas[3]?.nombre) ? props.data.entity.valor4 : '',
      valor5: (props.data.columnas[4]?.nombre) ? props.data.entity.valor5 : '',
      valor6: (props.data.columnas[5]?.nombre) ? props.data.entity.valor6 : '',
      valor7: (props.data.columnas[6]?.nombre) ? props.data.entity.valor7 : '',
      valor8: (props.data.columnas[7]?.nombre) ? props.data.entity.valor8 : '',
      valor9: (props.data.columnas[8]?.nombre) ? props.data.entity.valor9 : '',
      valor10: (props.data.columnas[9]?.nombre) ? props.data.entity.valor10 : '',
      valorResultado: props.data.entity.valorResultado
    });
  }
  useEffect(mount, [props.data.entity]);

  const { errorOf, validate } = useFormErrors(getErrors);

  //handles
  const handleClickAceptar = () => {
    if (validate()) {

      let row = CloneObject(entity);
      row.valor1 = formValues.valor1;
      row.valor2 = formValues.valor2;
      row.valor3 = formValues.valor3;
      row.valor4 = formValues.valor4;
      row.valor5 = formValues.valor5;
      row.valor6 = formValues.valor6;
      row.valor7 = formValues.valor7;
      row.valor8 = formValues.valor8;
      row.valor9 = formValues.valor9;
      row.valor10 = formValues.valor10;
      row.valorResultado = formValues.valorResultado;

      props.onConfirm(row);
    };
  };
  //funciones
  function getErrors() {
    const errors = {};

    if (!isValidString(formValues.valorResultado, true)) errors.valorResultado = VALIDATION_MESSAGE.REQUIRED;

    for (const columna of props.data.columnas) {
      if (!isValidString(formValues[`valor${columna.id}`], true)) errors[`valor${columna.id}`] = VALIDATION_MESSAGE.REQUIRED;
    }

    return errors;
  }

  return (
    <>

    <Modal
      size="lg"
      title="Valores"
      onEscape={() => props.onDismiss()}
      body={(
            <div className="row">
                {props.data.columnas.map((columna, index) =>
                <div className="mb-3 col-12 col-md-6" key={columna.id}>
                    <FormLabel htmlFor={`valor${columna.id}`} required>{columna.descripcion}</FormLabel>
                    <input
                      name={`valor${columna.id}`}
                      type="text"
                      placeholder=""
                      className={`form-control ${errorOf(`valor${columna.id}`) ? 'is-invalid' : ''}`}
                      value={formValues[`valor${columna.id}`]}
                      onChange={formHandle}
                      maxLength={250}
                      disabled={props.disabled}
                    />
                    <FormError message={errorOf(`valor${columna.id}`)} />
                </div>
                )}
                <div className="mb-3 col-12 col-md-6">
                    <FormLabel htmlFor="valorResultado" required>{props.data.resultado.descripcion}</FormLabel>
                    <InputCustom
                      name="valorResultado"
                      type={props.data.resultado.tipoDato}
                      placeholder=""
                      className="form-control"
                      value={formValues.valorResultado}
                      onChange={formHandle}
                      maxLength={250}
                      disabled={props.disabled}
                      serialize={true}
                      invalid={!!errorOf('valorResultado')}
                    />
                    <FormError message={errorOf('valorResultado')} />
                </div>
            </div>
      )}
      footer={!props.disabled ? (<>
            <button className="btn btn-outline-primary" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Cancelar</button>
            <button className="btn btn-primary" data-dismiss="modal" onClick={ (event) => handleClickAceptar() }>Aceptar</button>
      </>) : (
            <button className="btn back-button" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Volver</button>
      )}
      footerClassName={props.disabled ? 'f-align' : ''}
    />

    </>
  );
}

TablaItemModal.propTypes = {
  disabled: bool,
  data: object.isRequired,
  onConfirm: func.isRequired,
  onDismiss: func.isRequired,
};

TablaItemModal.defaultProps = {
  disabled: false
};

export default TablaItemModal;